import { render, staticRenderFns } from "./LocationNode.vue?vue&type=template&id=63d9393f&"
import script from "./LocationNode.vue?vue&type=script&lang=js&"
export * from "./LocationNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports